export default __webpack_public_path__ + "static/media/spratt5.a8f81e68.jpg";